import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Header from '../components/Header';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const { user } = useAuth();
  const { login } = useAuth();
  // const { login, loginGoogle } = useAuth();

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/');
    }
  }, [user]);

  useEffect(() => {
    if (error) {
      setLoading(false);
    }
  }, [error]);

  const submitHandler = (e) => {
    e.preventDefault();
    const credentials = {
      email: email,
      password: password,
    };
    setLoading(true);
    setError(null);
    login(credentials)
      .then(() => {
        setLoading(false);
        navigate('/');
      })
      .catch((error) => {
        setLoading(false);
        setError(error.response.data.message);
        setPassword('');
      });
  };

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container d-flex flex-column justify-content-center align-items-center login-center'>
        <form
          className='Login col-md-8 col-lg-4 col-11'
          onSubmit={submitHandler}
        >
          <input
            type='email'
            placeholder='Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ fontWeigth: 'bold', color: 'black' }}
            className={error ? 'error-input' : ''}
          />
          <input
            type='password'
            placeholder='Password'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ fontWeigth: 'bold', color: 'black' }}
            className={error ? 'error-input' : ''}
          />
          {error && (
            <div className='error-message'>
              <div className='d-flex align-items-start'>
                <i className='fas fa-exclamation-triangle me-2 mt-1' style={{ fontSize: '0.875rem' }}></i>
                <small className='flex-grow-1'>
                  Email o contraseña incorrectos. <br/>Por favor, inténtalo de nuevo.
                </small>
              </div>
            </div>
          )}
          <button type='submit' disabled={loading}>
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Cargando...
              </>
            ) : (
              'Acceder'
            )}
          </button>
          <p className='text-center mt-3'>
            <Link 
              to={'/forgot-password'} 
              style={{ 
                fontSize: '14px', 
                color: '#007bff', 
                textDecoration: 'underline' 
              }}
            >
              ¿Olvidaste tu contraseña?
            </Link>
          </p>
          <p>
            <Link to={'/register'}>Crear una cuenta</Link>
          </p>
        </form>
      </div>
    </>
  );
};

export default Login;
